import { useRouter } from "next/router";

import usePresentModeContext from "@/view/utils/usePresentModeContext";
import PresentModeBanner from "./PresentModeBanner";
import PreviewModeBanner from "./PreviewModeBanner";

import type { LangstonContentResponse } from "@/types/models";

interface ViewPageBannerProps {
  content: LangstonContentResponse | null | undefined;
  toggleBannerMode: () => void;
  bannerRef: React.ForwardedRef<HTMLDivElement>;
}

const ViewPageBanner = ({
  content,
  toggleBannerMode,
  bannerRef,
}: ViewPageBannerProps) => {
  const { query } = useRouter();
  const previewFor = `${query["preview_for"] || ""}`;

  const { isPresentModeActive, setIsPresentModeActive } =
    usePresentModeContext();

  if (isPresentModeActive) {
    return (
      <PresentModeBanner
        contentId={content?.id}
        contentType={content?.content_type}
        handleToggleBannerMode={toggleBannerMode}
        bannerRef={bannerRef}
        setIsPresentModeActive={setIsPresentModeActive}
      />
    );
  }

  return (
    <PreviewModeBanner
      bannerRef={bannerRef}
      contentId={content?.id}
      contentType={content?.content_type}
      handleToggleBannerMode={toggleBannerMode}
      previewFor={previewFor}
    />
  );
};

export default ViewPageBanner;
